// extracted by mini-css-extract-plugin
export default {"connectWallet":"VmmsrpyZmt4kMR35xupuyQ==","connectWalletText":"EwuBiD42VgcAwO5A--Njkw==","hasCoinIcon":"NsZhDC7BDgx9rOJAeW-BCw=="};